import React, { useState } from 'react';
import ErrorBoundary from 'components/common/ErrorBoundary';
import DebounceTextInput from 'components/DebounseTextInput';
import PendingTable from './components/PendingTable';

const Pending = ({ handleViewDetail }) => {
  const [searchString, setSearchString] = useState('');

  const handleChange = (value) => {
    setSearchString(value);
  };
  return (
    <ErrorBoundary>
      <div className="text-end">
        <DebounceTextInput
          onInputChange={handleChange}
          delay={500} // Set your desired delay in milliseconds
          value={searchString}
          placeholder="Search by Bill To"
          positionTop="-45px"
          positionRight="20px"
        />
      </div>
      <PendingTable
        searchString={searchString}
        handleViewDetail={handleViewDetail}
      />
    </ErrorBoundary>
  );
};

export default Pending;
